import _objectSpread from "/azp/_work/6/s/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.object.keys.js";
import { mapGetters } from 'vuex';
import SidebarItem from './SidebarItem';
import _variables from '@/styles/variables.module.scss';
import request from '@/request';
import cacheInLocalStorage from '@/store/cache/cacheInLocalStorage';
export default {
  components: {
    SidebarItem: SidebarItem
  },
  props: {
    isAdmin: {
      type: Boolean,
      default: undefined
    }
  },
  data: function data() {
    return {
      visible: false,
      defaultActiveMenu: '',
      staffInfo: cacheInLocalStorage.get('staffInfo') ? JSON.parse(cacheInLocalStorage.get('staffInfo')) : null
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler: function handler(route) {
        var _this = this;
        this.$nextTick(function () {
          var meta = route.meta,
            path = route.path;
          if (meta.activeMenu) {
            _this.defaultActiveMenu = meta.activeMenu;
          } else {
            _this.defaultActiveMenu = path;
          }
        });
      }
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['permission_routes', 'sidebar'])), {}, {
    showLogo: function showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables: function variables() {
      return _variables;
    },
    isCollapse: function isCollapse() {
      return !this.sidebar.opened;
    }
  }),
  created: function created() {
    var _this2 = this;
    this.$bus.$on('updateActiveMenu', function (val) {
      if (val) {
        _this2.$nextTick(function () {
          _this2.defaultActiveMenu = val;
        });
      }
    });
    this.$bus.$on('need-update-admin-clearance-add-count', function (val) {
      // 列表审结或者退单时要刷新新增显示
      _this2.httpGetNewCount();
    });
    var isB = cacheInLocalStorage.get('isB');
    if (isB) {
      this.httpGetNewCount();
      setInterval(function () {
        _this2.httpGetNewCount();
      }, 1000 * 10);
    }
  },
  methods: {
    exportExcel: function exportExcel() {
      this.$emit('show', true);
    },
    onMenuSelect: function onMenuSelect(index, indexPath) {
      if (index === '/customers-status-query') {
        this.$refs.menu.close('/customers-center');
        this.$refs.menu.close('/customs-clearance-supply');
      }
    },
    httpGetNewCount: function httpGetNewCount() {
      var _this3 = this;
      var url = '';
      if (this.staffInfo && (this.staffInfo.roleList[0].fixedRole === '主管理员' || this.staffInfo.roleList[0].fixedRole === '异常处理管理员')) {
        url = '/api/v1/business/admin/declarations/total-count';
      } else {
        url = '/api/v1/business/declarations/total-count';
      }
      request({
        url: url,
        method: 'get',
        hiddenLoading: true
      }).then(function (res) {
        _this3.$bus.$emit('update-admin-clearance-add-count', res);
      });
    }
  }
};